﻿import { extend, formattedNumber } from 'Furillo/modules/helpers.js';

export default class EsemZissonSocialboards {

    constructor(element, options) {

        const defaults = {};

        this.element = element;
        this.options = extend(defaults, options);
        
        this.init();
    }

    getSiblings(elem) {
            return Array.from(elem.parentNode.children).filter((sibling) => sibling !== elem);
    };

    init() {
        const self = this;

        const baseUrl = self.element.getAttribute('data-base-url');

        // View count
        self.element.querySelectorAll('.accordion-collapse[data-topicid]').forEach(collapse => {
            collapse.addEventListener('shown.bs.collapse', event => {

                const topicId = parseInt(event.target.getAttribute('data-topicid'));
                if (isNaN(topicId))
                    return;

                // Simply "fire and forget" registering view count
                fetch(baseUrl + '/viewcount/' + topicId, {
                    method: 'GET',
                    mode: 'same-origin',
                    cache: 'no-cache'
                }).catch(function (err) {
                    console.warn('Something went wrong registering views.', err);
                });
            });
        });

        // "Show all"
        self.element.querySelectorAll('button[data-target-accordion]').forEach(button => {

            button.addEventListener('click', event => {

                const targetAccordion = event.target.getAttribute('data-target-accordion');
                const accordion = self.element.querySelector(targetAccordion);
                if (!accordion)
                    return;

                accordion.querySelectorAll('.accordion-item.hidden').forEach(item => {
                    item.classList.remove('hidden');
                });

                event.target.parentElement.classList.add('hidden');
            });
        });

        // Feedback
        self.element.querySelectorAll('.feedback button[data-feedback]').forEach(button => {
            
            button.addEventListener('click', event => {

                const container = event.target.parentElement;

                console.log('target', event.target);
                console.log('container', container);

                const feedback = event.target.getAttribute('data-feedback');
                container.querySelectorAll('button,.feedback-main-title').forEach(button => { 
                    button.classList.add('hidden');
                });

                const feedbackContainer = container.querySelector('div[data-feedback="' + feedback + '"]');
                const form = container.querySelector('form');

                feedbackContainer.classList.remove('hidden');               
                                
                if (feedback == 'positive') {

                    const data = new FormData(form);

                    // Simply "fire and forget"
                    fetch(baseUrl + '/vote', {
                        method: 'POST',
                        mode: 'same-origin',
                        cache: 'no-cache',
                        body: data
                    }).catch(function (err) {
                        console.warn('Something went wrong registering vote.', err);
                    });

                    return;
                }

                form.querySelector('input[name="isLiked"]').value = 'false';

                const customerServiceBodyHtml = document.getElementById('customer-service-information');
                if (customerServiceBodyHtml) {
                    container.querySelector('div.customer-service-container').innerHTML = customerServiceBodyHtml.innerHTML;
                }

                // Wait 5 seconds to allow for giving a reason
                setTimeout(function () {
                    const data = new FormData(form);

                    // Simply "fire and forget"
                    fetch(baseUrl + '/vote', {
                        method: 'POST',
                        mode: 'same-origin',
                        cache: 'no-cache',
                        body: data
                    }).catch(function (err) {
                        console.warn('Something went wrong registering vote.', err);
                    });
                }, 5000);

            });
        });
    }
}